import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {Observable} from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ProductsService {
    /**
     * API URL
     * @private
     */
    private readonly apiUrl = environment.newApiUrl;

    /**
     * Constructor
     * @param http - Angular Http Client
     */
    constructor(private http: HttpClient) {
    }
   
    /**
     * [GET] Get All Products
     */
    public list(): Observable<any> {
        return this.http.get(`${this.apiUrl}/product/`);
    }
}
